var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgF(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.50003C11 1.22389 10.7761 1.00003 10.5 1.00003H8C5.37932 0.869487 3.14528 2.88012 3 5.50003V8.20003H0.5C0.223858 8.20003 0 8.42389 0 8.70003V11.3C0 11.5762 0.223858 11.8 0.5 11.8H3V18.5C3 18.7762 3.22386 19 3.5 19H6.5C6.77614 19 7 18.7762 7 18.5V11.8H9.62C9.84874 11.8033 10.0505 11.6509 10.11 11.43L10.83 8.83003C10.8703 8.6803 10.8389 8.52034 10.7449 8.397C10.6509 8.27366 10.5051 8.2009 10.35 8.20003H7V5.50003C7.05154 4.98713 7.48452 4.59745 8 4.60003H10.5C10.7761 4.60003 11 4.37617 11 4.10003V1.50003Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF);
export default __webpack_public_path__ + "static/media/f.74cbc1a0a5c13459a2a078302195b086.svg";
export { ForwardRef as ReactComponent };